import { useState, useEffect } from 'react';

import DenounceService from "../services/DenounceService";
import LogUtils from "../utils/LogUtils";

const TAG = "useDenounceService";
const logUtils = new LogUtils();

export function useGetAgentDenounces({ agentId }) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [denounces, setDenounces] = useState([]);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setDenounces([]);
    };
  }, []);

  useEffect(() => {
    async function getDenounces() {
      try {
        if (!isMounted) return false;

        setIsLoading(true);
        const denounceService = new DenounceService();
        const response = await denounceService.getAgentUserDenounces(agentId);
        setIsLoading(false);

        if (!isMounted || !response?.data) return false;

        setDenounces(response.data);

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getDenounces", err);
        setIsLoading(false);
      }
    }

    getDenounces({ agentId });

    return () => {
      setDenounces([]);
    };
  }, [isMounted, agentId]);

  return [isLoading, denounces];
}

export function useGetDenounce({ id }) {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(null);
  const [denounce, setDenounce] = useState(null);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
      setDenounce(null);
    };
  }, []);

  useEffect(() => {
    async function getDenounce({ id }) {
      try {
        if (!isMounted) return false;

        setIsLoading(true);
        const denounceService = new DenounceService();
        const response = await denounceService.getDenounce(id);
        setIsLoading(false);

        if (!isMounted || !response?.data) return false;

        setDenounce(response.data);

      } catch (err) {
        logUtils.logErrorMsg(TAG, "Failed to getDenounce", err);
        setIsLoading(false);
      }
    }

    getDenounce({ id });

    return () => {
      setDenounce(null);
    };
  }, [isMounted, id]);

  return [isLoading, denounce];
}
